<template>
    <el-select v-if="!loading" v-model="currency" filterable @change="updateCurrency">
        <el-option-group
            v-for="currencyAvailable in currenciesAvailable"
            :key="currencyAvailable.label"
        >
            <el-option
                v-for="option in currencyAvailable.options"
                :key="option.id"
                :label="option[mode]"
                :value="option.name"
            >
                <span class="fleft">{{ option.longname }}</span>
                <span class="fright fs-3 gray-60">{{ option.symbol }}</span>
            </el-option>
        </el-option-group>
    </el-select>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('system');

export default {
    props: {
        mode: {
            type: String,
            required: false,
            default: 'longname',
            validator: function (value) {
                return ['longname', 'symbol'].includes(value);
            },
        },
        modelValue: {
            type: String,
            required: false,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            loading: false,
            currenciesAvailable: [],
            topsCurrencies: ['EUR', 'USD', 'YEN', 'GBP'],
            currency: this.modelValue,
        };
    },
    computed: {
        ...mapState({
            allCurrencies: 'currencies',
        }),
    },
    created() {
        if (this.modelValue) {
            const found = this.allCurrencies.find((currency) => currency.name === this.modelValue);
            if (!found) {
                this.currency = this.topsCurrencies[0];
                this.updateCurrency();
            }
        }
        this.sortCurrencies(this.allCurrencies);
    },
    methods: {
        updateCurrency() {
            this.$emit(
                'update:modelValue',
                this.allCurrencies.find((currency) => currency.name === this.currency),
            );
        },
        sortCurrencies(data) {
            data.sort(function (a, b) {
                if (a.longname < b.longname) {
                    return -1;
                }
                if (a.longname > b.longname) {
                    return 1;
                }
                return 0;
            });

            const tops = [];
            const others = [];
            data.forEach((currency) => {
                if (this.topsCurrencies.includes(currency.name)) {
                    tops.push(currency);
                } else {
                    others.push(currency);
                }
            });

            this.currenciesAvailable = [
                {
                    label: 'tops',
                    options: tops,
                },
                {
                    label: 'others',
                    options: others,
                },
            ];
        },
    },
};
</script>
